var _effectorFileName = "/src/page-content/home/ui.tsx";
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { WebPageJsonLd } from 'next-seo';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Pricing } from '@/widgets/layouts/main/pricing/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { HowWorkStarts } from './components/how-work-starts/how-work-starts';
import { Main } from './components/main';
export const HomePage = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation('home-page');
  return <>
      <PageSeo title={t('seo.title')} description={t('seo.description')} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}`} name={`${APP_TITLE} - ${t('seo.name')}`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}`} description={t('seo.description')} about={t('seo.about', {
      returnObjects: true
    }) as string[]} />

      <Main />

      <HowWorkStarts />

      <Reviews title={t('reviews.title')} />

      <Pricing servicesList={SERVICES_LIST} />

      <CallToAction withForm />
    </>;
};
HomePage.Layout = MainLayout;